import { useNavigate } from "react-router-dom";
import SortBar from "./SortBar";
import FilterPanel from "./FilterPanel";

interface HeaderProps {
  city: string;
  showFilter: boolean;
  activeSort: number;
  priceRange: number;
  selectedStars: number[];
  onToggleFilter: () => void;
  onSortChange: (index: number) => void;
  onPriceChange: (index: number) => void;
  onStarToggle: (starValue: number) => void;
  onLocationClick?: () => void;
}

export default function Header({
  city,
  showFilter,
  activeSort,
  priceRange,
  selectedStars,
  onToggleFilter,
  onSortChange,
  onPriceChange,
  onStarToggle,
  onLocationClick,
}: HeaderProps) {
  const navigate = useNavigate();

  return (
    <div
      className="bg-white sticky top-0 z-40"
      style={{ boxShadow: "0 1px 0 #F3F4F6" }}
    >
      {/* 导航栏 */}
      <div className="px-4 pb-3 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
          style={{ background: "#F3F4F6" }}
        >
          <i
            className="ri-arrow-left-line"
            style={{ fontSize: 20, color: "#374151" }}
          />
        </button>
        <button
          onClick={onLocationClick}
          className="flex-1 flex items-center gap-2 rounded-xl px-3 py-2 cursor-pointer"
          style={{ background: "#F3F4F6" }}
        >
          <i
            className="ri-map-pin-line"
            style={{ color: "#1E3A8A", fontSize: 15 }}
          />
          <span className="text-sm font-semibold text-gray-800">{city}</span>
        </button>
        <button
          onClick={onToggleFilter}
          className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
          style={{ background: showFilter ? "#EFF6FF" : "#F3F4F6" }}
        >
          <i
            className="ri-equalizer-2-line"
            style={{ color: showFilter ? "#1E3A8A" : "#6B7280", fontSize: 18 }}
          />
        </button>
      </div>

      {/* 排序标签 */}
      <SortBar activeSort={activeSort} onChange={onSortChange} />

      {/* 筛选面板 */}
      {showFilter && (
        <FilterPanel
          priceRange={priceRange}
          selectedStars={selectedStars}
          onPriceChange={onPriceChange}
          onStarToggle={onStarToggle}
        />
      )}
    </div>
  );
}
